import axios from "@/plugins/axios";


export default {
    list(creditors_ids, mes, ano) {
        let params = {
            mes: mes,
            ano: ano,
            limit: 3000
        }
        if (creditors_ids && (creditors_ids.length !== 0)) {
            params.creditors = creditors_ids.join(',')
        }

        return axios.httpApi.get("/events", { params: params });
    },
    listPeriod(creditors_ids, startDate, endDate) {
        let params = {
            limit: 3000
        }
        if (creditors_ids && (creditors_ids.length !== 0)) {
            params.creditors = creditors_ids.join(',')
        }
        if (startDate) params.start_date = startDate
        if (endDate) params.end_date = endDate

        return axios.httpApi.get("/events", { params: params });
    },
    create(event) {
        return axios.httpApi.post("/events", event);
    },
    update(id, alteracoes) {
        return axios.httpApi.patch("/events/" + id, alteracoes);
    },
    remove(id) {
        return axios.httpApi.delete("/events/" + id);
    }
}